import {PAGE_URL, PERMISSION_KEY} from "../services/constant";

const nebulaUltraPlanMenuRegistry = {
    personalize_nebulaUltraPlan: {
        label: "Nebula Ultra Plan",
        link: PAGE_URL.NEBULA_ULTRA_PLAN_PAGE,
        key: PAGE_URL.NEBULA_ULTRA_PLAN_PAGE,
        resourceKey: PERMISSION_KEY
    }
};
export default nebulaUltraPlanMenuRegistry;
